import api from './api';
import { LocationData } from '@/types/location.types';

/**
 * Location Service
 * Handles all location-related API calls
 */
export class LocationService {
  /**
   * Get all member locations
   * @param state Optional state filter
   * @returns Array of locations
   */
  static async getLocations(state?: string): Promise<LocationData[]> {
    try {
      const params = state ? { state } : {};
      const response = await api.get('/member-locations/all-locations', { params });
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Failed to fetch locations';
      throw new Error(message);
    }
  }

  /**
   * Get user's current location
   * @returns User's location
   */
  static async getMyLocation(): Promise<LocationData> {
    try {
      const response = await api.get('/member-locations/my-location');
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Failed to fetch user location';
      throw new Error(message);
    }
  }

  /**
   * Get location by ID
   * @param locationId Location ID
   * @returns Location details
   */
  static async getLocationById(locationId: string): Promise<LocationData> {
    try {
      const response = await api.get(`/member-locations/${locationId}`);
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        'Failed to fetch location';
      throw new Error(message);
    }
  }
}

export default LocationService;
